
export enum UserRole{
  ADMIN= "ADMIN",
  CHECK = "CHECK",
  SUPERADMIN= 'SUPER'
}
